export const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader-inner"></div>
      <div className="loader-spinner"></div>
    </div>
  );
};
